var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealTimeVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UEhGzk.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M34.744,16.286c0.129,3.439-1.779,6.305-4.206,8.926 c-2.28,2.465-4.508,4.957-5.812,8.124c-0.312,0.759-1.136,0.83-1.425,0.12c-1.557-3.827-4.514-6.608-7.093-9.679 c-2.84-3.379-3.792-7.191-2.343-11.437c1.75-5.129,6.631-7.978,11.562-7.219C31.106,5.996,34.755,10.356,34.744,16.286z  M23.991,10.094c-3.139-0.005-5.715,2.485-5.763,5.572c-0.048,3.157,2.6,5.861,5.741,5.863c3.073,0.003,5.721-2.585,5.755-5.625 C29.762,12.683,27.213,10.099,23.991,10.094z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M41.945,30.065c1.76,3.869,3.509,7.671,5.219,11.486 c0.42,0.937,0.073,1.429-0.951,1.436c-2.685,0.018-5.368,0.014-8.052-0.002c-0.301-0.003-0.638-0.073-0.895-0.223 c-3.667-2.104-7.324-4.225-10.982-6.344c-0.083-0.051-0.15-0.132-0.322-0.286c0.699-1.089,1.369-2.2,2.117-3.255 c0.188-0.265,0.61-0.441,0.953-0.505C33.291,31.596,37.554,30.845,41.945,30.065z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M31.147,42.995c-0.342,0-0.684,0-1.025,0 c-9.284,0-18.565,0-27.848,0c-1.718,0-1.949-0.366-1.231-1.941c0.525-1.152,1.013-2.324,1.604-3.443 c0.179-0.338,0.617-0.687,0.988-0.756c4.221-0.785,8.45-1.52,12.681-2.251c0.285-0.051,0.648-0.032,0.889,0.104 c4.674,2.674,9.335,5.371,13.999,8.063C31.185,42.847,31.167,42.92,31.147,42.995z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M13.797,32.72c-3.375,0.594-6.447,1.133-9.731,1.709 c0.916-2.017,1.747-3.849,2.631-5.795C9.051,29.988,11.312,31.291,13.797,32.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M19.309,31.854c-0.454-0.079-0.973-0.045-1.354-0.259 c-2.762-1.547-5.496-3.143-8.227-4.919c1.716,0,3.431-0.012,5.146,0.019c0.159,0.002,0.328,0.249,0.469,0.402 c1.358,1.478,2.711,2.958,4.065,4.439C19.376,31.643,19.343,31.749,19.309,31.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#006EC5",
    d: "M40.993,27.917c-3.467,0.613-6.718,1.189-10.014,1.771 c0.648-1.703,2.466-3.043,4.047-3.043c1.235,0,2.471,0.01,3.706-0.004C39.652,26.633,40.325,27.034,40.993,27.917z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeVisibility);
export default __webpack_public_path__ + "static/media/Real_time_visibility.bf1ba42207d64f1d8c4dce819f66d4b9.svg";
export { ForwardRef as ReactComponent };